import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { OTO_LINK, PRICE_CONFIGURATIONS } from 'services/consts';

const initialState = {
	settings: [],
	deliveryCompanies: [],
	isLoadingDeliveryCompanies: false
};

export const getOTOLinkSettings = createAsyncThunk('otoLinkSettings/fetchAll', async (_, { getState }) => {
	const { otoLinkSettings } = getState();

	if (otoLinkSettings.lenth > 0) {
		return otoLinkSettings;
	}

	const axiosPrivate = useAxiosPrivate();
	const response = await axiosPrivate.post(OTO_LINK.GET_OTO_LINK_SETTINGS);
	return response.data;
});

// Add new thunk for delivery companies
export const getDeliveryCompanies = createAsyncThunk('otoLinkSettings/getDeliveryCompanies', async (params) => {
	if (!params.pickupType) {
		return [];
	}
	const axiosPrivate = useAxiosPrivate();
	const response = await axiosPrivate.post(PRICE_CONFIGURATIONS.GET_ADVANCED_DELIVERY_COMPANY_AUTOCOMPLETE, params);
	return response.data;
});

const otoLinkSettings = createSlice({
	name: 'otoLinkSettings',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getOTOLinkSettings.fulfilled, (state, { payload }) => ({
				...state,
				settings: payload
			}))
			.addCase(getDeliveryCompanies.pending, (state) => ({
				...state,
				isLoadingDeliveryCompanies: true
			}))
			.addCase(getDeliveryCompanies.fulfilled, (state, { payload }) => ({
				...state,
				deliveryCompanies: payload,
				isLoadingDeliveryCompanies: false
			}))
			.addCase(getDeliveryCompanies.rejected, (state) => ({
				...state,
				isLoadingDeliveryCompanies: false
			}));
	}
});

export default otoLinkSettings.reducer;
